(function () {
  'use strict';

  angular.module('service.crocodoc', [])
    .factory('Crocodoc', Crocodoc);

  Crocodoc.$inject = ['$window'];

  function Crocodoc($window) {

    return $window.Crocodoc;

  }

})();
